import createIcon from '../../createIcon';

/**
 * @component @name Cancel
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIgMkM2LjQ3IDIgMiA2LjQ3IDIgMTJDMiAxNy41MyA2LjQ3IDIyIDEyIDIyQzE3LjUzIDIyIDIyIDE3LjUzIDIyIDEyQzIyIDYuNDcgMTcuNTMgMiAxMiAyWk0xNyAxNS41OUwxNS41OSAxN0wxMiAxMy40MUw4LjQxIDE3TDcgMTUuNTlMMTAuNTkgMTJMNyA4LjQxTDguNDEgN0wxMiAxMC41OUwxNS41OSA3TDE3IDguNDFMMTMuNDEgMTJMMTcgMTUuNTlaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Cancel = createIcon('Cancel', [
  [
    'path',
    {
      d: 'M12 2C6.47 2 2 6.47 2 12C2 17.53 6.47 22 12 22C17.53 22 22 17.53 22 12C22 6.47 17.53 2 12 2ZM17 15.59L15.59 17L12 13.41L8.41 17L7 15.59L10.59 12L7 8.41L8.41 7L12 10.59L15.59 7L17 8.41L13.41 12L17 15.59Z',
      key: '1ik5dw',
    },
  ],
]);

export default Cancel;
